module.exports = require("@pb/kit-util-smooth-scroll");